import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }
    sr.reveal(revealContainer.current, srConfig());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const skills = [
    'Python', 'JavaScript (ES6+)', 'TypeScript', 'C++', 'C#', 'Java',
    'React.js', 'Next.js', 'Node.js', 'Express.js', 'TensorFlow', 'PyTorch',
    'scikit-learn', 'Figma', 'Pandas', 'NumPy', 'SQL/MySQL', 'MongoDB',
    'Oracle DB', 'Docker', 'Git & GitHub', 'Selenium', 'Postman', 'Cloud Platforms',
  ];

  return (
    <section id="about" ref={revealContainer} className="max-w-[900px]">
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner grid grid-cols-[3fr_2fr] gap-[50px] max-[768px]:block">

        {/* Text column */}
        <div>
          <div>
            <p>
              Hello! I&apos;m Muhammad Sarim. My journey in software engineering began with a
              curiosity about how technology solves real-world problems. Today, that passion drives
              me to engineer world-class, intelligent products that push the boundaries of what&apos;s
              possible in the digital space.
            </p>

            <p>
              From training complex AI models to deploying highly scalable cloud architectures, my
              focus is bridging the gap between cutting-edge Machine Learning and seamless
              cross-platform experiences.
            </p>

            <p>
              I regularly share my insights on software engineering, AI, and modern development
              practices through articles and community involvement.
            </p>

            <p>Here are a few technologies I&apos;ve been working with recently:</p>
          </div>

          {/* skills-list bullet styles defined in global.css */}
          <ul className="skills-list grid grid-cols-[repeat(3,minmax(120px,180px))] gap-y-0 gap-x-[10px] p-0 mt-5 mb-0 overflow-hidden list-none max-[768px]:grid-cols-[repeat(2,minmax(140px,200px))]">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </div>

        {/* Picture column */}
        <div className="relative max-w-[300px] max-[768px]:mx-auto max-[768px]:mt-[50px] max-[768px]:w-[70%]">
          {/* pic-wrapper + ::before/::after defined in global.css */}
          <div className="pic-wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpeg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
